export default "__VITE_ASSET__CUtkshln__"